import { render, staticRenderFns } from "./companyBenefitSetups.vue?vue&type=template&id=0653562c"
import script from "./companyBenefitSetups.vue?vue&type=script&lang=js"
export * from "./companyBenefitSetups.vue?vue&type=script&lang=js"
import style0 from "./companyBenefitSetups.vue?vue&type=style&index=0&id=0653562c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports